import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import TableContainer from "../../../../components/Common/TableContainer";
import { TUserMachineWithRole } from "../../types";
import { useNavigate } from "react-router-dom";

import { COLUMNS } from "../../config";

interface Props {
    data: TUserMachineWithRole[];
}

const UserLinkedMachineList = ({ data }: Props) => {
    const navigate = useNavigate();

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardHeader>
                        <CardTitle className="font-size-24">Linked Machines</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <TableContainer
                            columns={COLUMNS}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={true}
                            isAddButton={false}
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            onRowClick={(rowData) => {
                                navigate(`/machines/${rowData.serialNumber}`);
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default UserLinkedMachineList;
